import { useMsal } from '@azure/msal-react';
import { Grow, Popper } from '@material-ui/core';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { allowedModules, APP_MODULES } from 'constants/appModules';
import { PATHS } from 'constants/paths';
import { FC, MouseEvent, MutableRefObject } from 'react';
import { useIntl } from 'react-intl';
import { NavLink } from 'react-router-dom';
import { useSelectUser } from 'redux/User/selectors';

import styles from './ProfilePopup.module.scss';
import TimezoneSelect from './components/TimezoneSelect';
import UnitSelect from './components/UnitSelect';

export interface Props {
  isOpen: boolean;
  anchorRef: MutableRefObject<HTMLButtonElement>;
  onHideProfilePopupClick: (event: MouseEvent<EventTarget>) => void;
}

const ProfilePopup: FC<Props> = ({ isOpen, anchorRef, onHideProfilePopupClick }) => {
  const intl = useIntl();
  const user = useSelectUser();
  const { instance } = useMsal();

  const handleSignOut = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: '/' });
  };

  return (
    <Popper
      open={isOpen}
      anchorEl={anchorRef.current}
      transition
      disablePortal
      className={styles.profileContainer}
    >
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: 'center top',
          }}
        >
          <Paper elevation={3} variant="outlined" className={styles.profilePaper}>
            <ClickAwayListener onClickAway={onHideProfilePopupClick}>
              <div>
                <Grid container alignItems="center" justify="space-between">
                  {user && (
                    <span
                      className={styles.profileName}
                    >{`${user.firstName} ${user.lastName}`}</span>
                  )}
                </Grid>
                <div className={styles.divider} />
                <TimezoneSelect />
                <div className={styles.divider} />
                <UnitSelect />
                <div className={styles.divider} />
                {user && (
                  <>
                    {allowedModules[user.profile].includes(APP_MODULES.USER_ADMIN) && (
                      <>
                        <NavLink
                          exact
                          activeClassName={styles.activeLink}
                          className={styles.link}
                          to={PATHS.USER_ADMIN}
                          onClick={onHideProfilePopupClick}
                        >
                          {intl.formatMessage({
                            id: 'header.profile.manageUsers',
                          })}
                        </NavLink>
                        <div className={styles.divider} />
                      </>
                    )}

                    {allowedModules[user.profile].includes(APP_MODULES.ADMIN_PO) && (
                      <>
                        <NavLink
                          activeClassName={styles.activeLink}
                          className={styles.link}
                          to={PATHS.ADMIN_PO}
                          onClick={onHideProfilePopupClick}
                        >
                          {intl.formatMessage({ id: 'header.profile.adminPo' })}
                        </NavLink>
                        <div className={styles.divider} />
                      </>
                    )}

                    <span className={styles.activeLink} onClick={handleSignOut} role="button">
                      {intl.formatMessage({ id: 'header.profile.signOut' })}
                    </span>
                  </>
                )}
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  );
};

export default ProfilePopup;
